/* ===================================================================
   TOL — click-to-load YouTube facade.
   Developer brief, 25 September 2026.

   Nothing is requested from YouTube until the customer presses play.
   On click the iframe is built with autoplay=1 and replaces the button
   in place, so the customer stays on the product page.

   One delegated listener covers every .tol-video on the page, present
   at load or injected later. The guard matters because this file is
   referenced from both main-product and custom-tabs: a page carrying
   the top-of-page video AND the tab videos would otherwise bind twice
   and build two iframes per click.
   =================================================================== */

(function () {
  if (window.__tolInstallVideoBound) return;
  window.__tolInstallVideoBound = true;

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.tol-video__trigger');
    if (!trigger) return;

    var wrap = trigger.closest('.tol-video');
    if (!wrap) return;

    var id = wrap.getAttribute('data-video-id');
    if (!id) return;

    var iframe = document.createElement('iframe');
    // youtube-nocookie, and playsinline=1 is what stops iOS Safari
    // forcing the video fullscreen out of the page.
    iframe.src =
      'https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(id) +
      '?autoplay=1&rel=0&playsinline=1&modestbranding=1';
    iframe.title = trigger.getAttribute('aria-label') || 'Install video';
    iframe.allow =
      'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;

    trigger.replaceWith(iframe);
    // Focus was on the button that has just been removed; move it to the
    // player so keyboard users are not dropped back to the top of the page.
    iframe.setAttribute('tabindex', '-1');
    iframe.focus({ preventScroll: true });
  });
})();
